import { ConsentPrivacySection } from "@/features/patient/consent/components/ConsentPrivacyView";
import { sampleConsentItems } from "@/data/patient/consent.mock";

export function ConsentPrivacyPage() {
  return <ConsentPrivacySection items={sampleConsentItems} />;
}
